export const MuiSkeleton = () => ({
  defaultProps: {
    animation: 'wave'
  }
})
